import { Box, SxProps, Theme } from '@mui/material';

interface StatusDotProps {
    active: boolean;
    size?: number;
    sx?: SxProps<Theme>;
}

export function StatusDot({ active, size = 10, sx }: StatusDotProps) {
    return (
        <Box
            sx={{
                width: size,
                height: size,
                borderRadius: '50%',
                backgroundColor: active ? '#22c55e' : '#d1d5db',
                boxShadow: active
                    ? '0 0 0 3px rgba(34, 197, 94, 0.2)'
                    : '0 0 0 3px rgba(209, 213, 219, 0.3)',
                ...sx,
            }}
        />
    );
}
